import React, {useEffect, useState, Fragment } from 'react';
import { Typography, List, Container, Stack, Paper } from '@mui/material';
import { backendFetch } from '../../backend/backend';
import Subtitle from '../ui/Subtitle';
import ChipListItem from '../art/ChipListItem';
import FixturesTable from '../tables/FixturesTable';
import FixtureGenerationRules from '../rules/FixtureGenerationRules';

const Fixtures = () => {
	const [thisSeasonFixtures,setThisSeasonFixtures]=useState([]);
	const [nextSeasonFixtures,setNextSeasonFixtures]=useState([]);
	const [fetched,setFetched]=useState(false);

	useEffect(()=> {
		async function fetchData() {
			const thisSeason=await backendFetch('fixtures?season=active');
			setThisSeasonFixtures(thisSeason);
			const nextSeason=await backendFetch('fixtures?season=next');
			setNextSeasonFixtures(nextSeason);
			setFetched(true);
		}
		fetchData();
	},[]);

	var nextSeasonHeader=<Fragment/>;
	if (nextSeasonFixtures.length>0) {
		nextSeasonHeader=<Subtitle text="Next Season"/>
	}

	return(
		<Stack>
			{fetched &&
			<Fragment>
				<Stack direction={{xs:"column",sm:"row"}} justifyContent="flex-start">
					<Stack spacing="0" sx={{width:{xs:"100%",sm:800}}}>
						<Subtitle text="Fixtures"/>
						<FixturesTable fixtures={thisSeasonFixtures}/>
					</Stack>
					<Stack spacing="0" sx={{width:{xs:"100%",sm:800}}}>
						{nextSeasonHeader}
						<FixturesTable fixtures={nextSeasonFixtures}/>
					</Stack>
				</Stack>
				<Paper>
					<Container>
						<Typography variant="h4">Notes</Typography>
						<List>
							<ChipListItem>
								Dates are fixed. If there are 2 absentees for any particular date negotiations can start for moving the date,
								but a date cannot be selected which is not acceptable to all players who could make the original date, without their express permission.
							</ChipListItem>
						</List>
					</Container>
                    <FixtureGenerationRules/>
				</Paper>
			</Fragment>
			}
		</Stack>
	);
}

export default Fixtures;